"use strict";
if (typeof require === "function") {
  var moment = require("moment");
}
export default function (date, futureMonth) {
  var currentDate = moment(date ? date : new Date());
  var futureDate = moment(currentDate).add(futureMonth, "M");
  return futureDate.toDate();
}
